import React, { PureComponent } from 'react';
import { Breadcrumb, Layout } from 'antd';
import { Link } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import EditAdjustLocation from './components/EditAdjustLocation';
import { getLeadOMConfigRequest } from '../Lead-o-matic_update/redux/actions/get_leadomatic_config.actions';
import { editLocationCriteria } from './requests/edit_location_criteria';

const BreadcrumbItem = Breadcrumb.Item;

class EditLocation extends PureComponent {
    componentDidMount() {
        this.props.getLeadOMConfigRequest();
    }

    render() {
        let locationCriteriaData = null;
        if (this.props.leadomaticConfig.config) {
            locationCriteriaData = this.props.leadomaticConfig.config && this.props.leadomaticConfig.config.location_criteria.find(el => el._id === this.props.match.params.id);
        }

        return (
            <Layout className="leadomatic-location-update-container">
                <Breadcrumb className="breadcrumbs">
                    <BreadcrumbItem><Link to="/PlatformManagement/Lead-o-matic_update">Lead-o-matic</Link></BreadcrumbItem>
                    <BreadcrumbItem>Configure Lead-o-matic</BreadcrumbItem>
                </Breadcrumb>
                <h3 className="page-title">Configure Location</h3>
                <h3 className="page-subhead subhead">Edit an existing location to the Lead-o-matic service</h3>
                {
                    this.props.leadomaticConfig.config
                    && locationCriteriaData
                    && (
                        <EditAdjustLocation
                            configId={this.props.leadomaticConfig.config._id}
                            locationId={this.props.match.params.id}
                            currentLCName={locationCriteriaData.name}
                            currentLCPostcode={locationCriteriaData.postcode}
                            currentLCRadius={locationCriteriaData.radius}
                            currentLCPriority={locationCriteriaData.priority}
                        />
                    )
                }
            </Layout>
        );
    }
}

// view://PlatformManagement/Lead-o-matic_update

const mapStateToProps = state => ({
    leadomaticConfig: state.PlatformManagement.Lead_o_matic_update,
});

export default connect(mapStateToProps, { getLeadOMConfigRequest, editLocationCriteria })(EditLocation);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_update/index.js